import cx from "classnames";
import { size } from "lodash";
import { MDBAnimation } from "mdbreact";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Button, Image } from "semantic-ui-react";
import logo_medpro from "~/assets/img/desktop/icon/logo.svg";
import bocongthuong1 from "~/assets/img/mobile/logo/bocongthuong1.svg";
import bocongthuong2 from "~/assets/img/mobile/logo/bocongthuong2.svg";
import { LINK_ANDROID_APP, LINK_IOS_APP } from "~/utils/manageResource";
import partnerId from "~/utils/partner";
import CopyRight from "../CopyRight";
import FooterDesktop from "../FooterDesktop";
import styles from "./style.module.scss";

const FooterNew = props => {
  /* --------- INFO------------ */
  const [openMenus, setOpenMenus] = useState([]);
  const toggleMenu = (item, index) => {
    if (item.link !== "#") {
      if (item?.link === "#") {
        setOpenMenus([openMenus.includes(index) ? -1 : index]);
      } else {
        window.location.href = item.link;
        setOpenMenus([openMenus.includes(index) ? -1 : index]);
      }
    } else {
      if (openMenus.includes(index)) {
        setOpenMenus(openMenus.filter(item => item !== index));
      } else {
        setOpenMenus([...openMenus, index]);
      }
    }
  };
  return (
    <MDBAnimation
      reveal="true"
      type="fadeIn"
      className={cx(styles.foorter, styles["footer_" + partnerId])}
    >
      <div className={styles.foorter}>
        <div className={styles.container}>
          <FooterDesktop data={dataFooter} />
          <div className={styles.mobile}>
            <Link href="/">
              <a rel="nofollow">
                <Image
                  src={logo_medpro}
                  width={122}
                  height={52.76}
                  layout="responsive"
                  alt="Logo Medpro Footer"
                />
              </a>
            </Link>
            <ul>
              <li>
                <span>Địa chỉ: </span>
                236/29/18 Điện Biên Phủ - Phường 17 - Quận Bình Thạnh - TPHCM.
              </li>
              <li>
                <span>Website: </span>
                https://medpro.vn
              </li>
              <li>
                <span>Email: </span>
                cskh@medpro.vn
              </li>
              <li>
                <span>Điện thoại: </span>
                (028) 710 78098
              </li>
            </ul>
            <hr className={styles.line} />
            <div className={styles.menuItemMobile}>
              <ul>
                {dataFooter.menuMobile
                  .filter(iteFil => iteFil.children)
                  .map((item, index) => {
                    return (
                      <li key={index} onClick={() => toggleMenu(item, index)}>
                        <div className={styles.title}>
                          <label>
                            <span>{item?.title}</span>
                          </label>

                          {size(item?.children) > 0 &&
                            (openMenus.includes(index) ? (
                              <i className="fas fa-angle-up" />
                            ) : (
                              <i className="fas fa-angle-down" />
                            ))}
                        </div>

                        {size(item?.children) > 0 && (
                          <ul
                            className={`${styles.listMenu} ${
                              openMenus.includes(index)
                                ? styles.showListMenu
                                : ""
                            }`}
                          >
                            {item?.children?.map((el, i) => (
                              <li key={i}>
                                <Button
                                  className={styles.subMenu}
                                  onClick={() => {
                                    toggleMenu(el, index);
                                  }}
                                >
                                  {el.label}
                                </Button>
                              </li>
                            ))}
                          </ul>
                        )}
                      </li>
                    );
                  })}
              </ul>
            </div>

            <hr className={styles.line} />
            <div className={styles.mobile}>
              <ul>
                {dataFooter.menuMobile
                  .filter(item => !item.children)
                  .map((item, index) => {
                    return (
                      <li key={index}>
                        <a
                          href={item.link}
                          target="_blank"
                          rel="nofollow noreferrer"
                        >
                          {item.title}
                        </a>
                      </li>
                    );
                  })}
              </ul>
            </div>
            <div className={styles.regis}>
              <div className={styles.download}>
                <div className={styles.content}>
                  <a
                    href={dataFooter?.downloads?.dkbct}
                    rel="noreferrer nofollow"
                    target="_blank"
                  >
                    <Image
                      src={bocongthuong1}
                      width={97}
                      height={30}
                      alt="Đã đăng kí bộ công thương"
                      layout="responsive"
                    />
                  </a>
                </div>
                <div className={styles.content}>
                  <a
                    href={dataFooter?.downloads?.tbbct}
                    rel="noreferrer nofollow"
                    target="_blank"
                  >
                    <Image
                      src={bocongthuong2}
                      width={97}
                      height={30}
                      alt="Đã thông báo bộ công thương"
                      layout="responsive"
                    />
                  </a>
                </div>
              </div>
              <div className={styles.download}>
                <div className={styles.right}>
                  <a
                    href={dataFooter?.downloads?.android}
                    rel="noreferrer nofollow"
                    target="_blank"
                  >
                    <Image
                      src="https://bo-api.medpro.com.vn/static/images/medpro/web/icon_google_play.svg?t=1111111"
                      width={97}
                      height={30}
                      alt="Tải ứng dụng Google Play"
                      layout="responsive"
                    />
                  </a>
                </div>
                <div className={styles.right}>
                  <a
                    href={dataFooter?.downloads?.ios}
                    rel="noreferrer nofollow"
                    target="_blank"
                  >
                    <Image
                      src="https://bo-api.medpro.com.vn/static/images/medpro/web/icon_ios.svg?t=11111111"
                      width={97}
                      height={30}
                      alt="Tải ứng dụng App Store"
                      layout="responsive"
                    />{" "}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <CopyRight />
        {/* <CopyRight />

        {!props.hiddenFooter
          ? props.isBottomTab &&
            ![
              "chon-lich-kham",
              "tao-moi-ho-so",
              "cap-nhat-thong-tin",
              "tim-ho-so-app",
              "xac-nhan-thong-tin-benh-nhan-app"
            ].includes(router.pathname.split("/")[1]) && (
              <>
                <div className={styles["footer"]}></div>
                <FooterMobileMenu
                  footerMenu={props.bottomTabMenu}
                  noReadNoti={props.unReadNoti}
                />
              </>
            )
          : ""} */}
      </div>
    </MDBAnimation>
  );
};

export default FooterNew;
const NewHospitalType = {
  PUBLIC_HOSPITAL: "benh-vien-cong",
  PRIVATE_HOSPITAL: "benh-vien-tu",
  PHONG_KHAM: "phong-kham",
  PHONG_MACH: "phong-mach",
  XET_NGHIEM: "xet-nghiem",
  Y_TE_TAI_NHA: "y-te-tai-nha",
  TIEM_CHUNG: "tiem-chung"
};
const menuCoSoYte = [
  {
    key: "1",
    label: "Bệnh viện công",
    link: `https://medpro.vn/co-so-y-te/${NewHospitalType.PUBLIC_HOSPITAL}`,
    sortOrder: 1
  },
  {
    key: "2",
    label: "Bệnh viện tư",
    link: `https://medpro.vn/co-so-y-te/${NewHospitalType.PRIVATE_HOSPITAL}`,
    sortOrder: 2
  },
  {
    key: "3",
    label: "Phòng khám",
    link: `https://medpro.vn/co-so-y-te/${NewHospitalType.PHONG_KHAM}`,
    sortOrder: 3
  },
  {
    key: "4",
    label: "Phòng mạch",
    link: `https://medpro.vn/co-so-y-te/${NewHospitalType.PHONG_MACH}`,
    sortOrder: 4
  },
  {
    key: "5",
    label: "Xét nghiệm",
    link: `https://medpro.vn/co-so-y-te/${NewHospitalType.XET_NGHIEM}`,
    sortOrder: 5
  },
  {
    key: "6",
    label: "Y tế tại nhà",
    link: `https://medpro.vn/co-so-y-te/${NewHospitalType.Y_TE_TAI_NHA}`,
    sortOrder: 6
  },
  {
    key: "7",
    label: "Tiêm chủng",
    link: `https://medpro.vn/co-so-y-te/${NewHospitalType.TIEM_CHUNG}`,
    sortOrder: 6
  }
];

export const NewsCategories = {
  ALL: "",
  TIN_DICH_VU: "tin-dich-vu",
  TIN_Y_TE: "tin-y-te",
  Y_HOC_THUONG_THUC: "y-hoc-thuong-thuc"
};
export const LINK_DANG_KY_BO_CO_THUONG =
  "http://online.gov.vn/Home/WebDetails/44668?AspxAutoDetectCookieSupport=1";
export const LINK_THONG_BAO_BO_CO_THUONG =
  "http://online.gov.vn/Home/WebDetails/44209";
export const dataFooter = {
  menuMobile: [
    {
      title: "Về Medpro",
      link: "https://medpro.vn/gioi-thieu",
      children: []
    },
    {
      title: "Hướng dẫn",
      link: "#",
      children: [
        {
          label: "Cài đặt ứng dụng",
          link: "https://medpro.vn/huong-dan/cai-dat-ung-dung"
        },
        {
          label: "Đặt lịch khám",
          link: "https://medpro.vn/huong-dan/dat-lich-kham"
        },
        {
          label: "Tư vấn khám bệnh qua video",
          link: "https://medpro.vn/huong-dan/tu-van-kham-benh-qua-video"
        },
        {
          label: "Quy trình hoàn phí",
          link: "https://medpro.vn/huong-dan/quy-trinh-hoan-phi"
        },
        {
          label: "Câu hỏi thường gặp",
          link: "https://medpro.vn/huong-dan/cau-hoi-thuong-gap"
        },
        {
          label: "Quy trình đi khám",
          link: "https://medpro.vn/huong-dan/quy-trinh-di-kham"
        }
      ]
    },
    {
      title: "Liên hệ hợp tác",
      link: "#",
      children: [
        {
          label: "Tham gia Medpro",
          link: `https://medpro.vn/hop-tac-cung-medpro`
        },
        {
          label: "Doanh nghiệp",
          link: `https://medpro.vn/kham-suc-khoe-doanh-nghiep`
        },
        {
          label: "Quảng cáo",
          link: `https://medpro.vn/hop-tac-quang-cao`
        },
        {
          label: "Tuyển Dụng",
          link: `https://medpro.vn/tuyen-dung`
        }
      ]
    },

    {
      title: "Điều khoản dịch vụ",
      link: "https://medpro.vn/dieu-khoan-dich-vu"
    },
    {
      title: "Chính sách bảo mật",
      link: "https://medpro.vn/chinh-sach-bao-mat"
    },
    {
      title: "Quy định sử dụng",
      link: "https://medpro.vn/quy-dinh-su-dung"
    }
  ],
  menu: [
    {
      title: "Dịch vụ Y tế",
      link: "",
      children: [
        {
          label: "Đặt khám tại cơ sở",
          link: "https://medpro.vn/dich-vu-y-te/dat-kham-tai-co-so"
        },
        {
          label: "Đặt khám bác sĩ",
          link: "https://medpro.vn/dich-vu-y-te/dat-kham-theo-bac-si"
        },
        {
          label: "Tư vấn khám bệnh qua video",
          link: "https://medpro.vn/dich-vu-y-te/tu-van-kham-benh-tu-xa"
        },
        {
          label: "Đặt lịch xét nghiệm",
          link: "https://medpro.vn/dich-vu-y-te/dat-lich-xet-nghiem"
        },
        {
          label: "Gói khám sức khỏe",
          link: "https://medpro.vn/dich-vu-y-te/goi-kham-suc-khoe"
        },
        {
          label: "Đặt lịch tiêm chủng",
          link: "https://medpro.vn/dich-vu-y-te/dat-lich-tiem-chung"
        },
        {
          label: "Y tế tại nhà",
          link: "https://medpro.vn/dich-vu-y-te/y-te-tai-nha"
        },
        {
          label: "Thanh toán viện phí",
          link: "https://medpro.vn/dich-vu-y-te/thanh-toan-vien-phi"
        }
      ]
    },
    {
      title: "Cơ sở y tế",
      link: "",
      children: menuCoSoYte
    },
    {
      title: "Hướng dẫn",
      link: "",
      children: [
        {
          label: "Cài đặt ứng dụng",
          link: "https://medpro.vn/huong-dan/cai-dat-ung-dung"
        },
        {
          label: "Đặt lịch khám",
          link: "https://medpro.vn/huong-dan/dat-lich-kham"
        },
        {
          label: "Tư vấn khám bệnh qua video",
          link: "https://medpro.vn/huong-dan/tu-van-kham-benh-qua-video"
        },
        {
          label: "Quy trình hoàn phí",
          link: "https://medpro.vn/huong-dan/quy-trinh-hoan-phi"
        },
        {
          label: "Câu hỏi thường gặp",
          link: "https://medpro.vn/huong-dan/cau-hoi-thuong-gap"
        },
        {
          label: "Quy trình đi khám",
          link: "https://medpro.vn/huong-dan/quy-trinh-di-kham"
        }
      ]
    },
    {
      title: "Liên hệ hợp tác",
      link: "",
      children: [
        {
          label: "Tham gia Medpro",
          link: `https://medpro.vn/hop-tac-cung-medpro`
        },
        {
          label: "Khám sức khỏe doanh nghiệp",
          link: `https://medpro.vn/kham-suc-khoe-doanh-nghiep`
        },
        {
          label: "Quảng cáo",
          link: `https://medpro.vn/hop-tac-quang-cao`
        },
        {
          label: "Tuyển Dụng",
          link: `https://medpro.vn/tuyen-dung`
        }
      ]
    },
    {
      title: "Tin tức",
      link: "",
      children: [
        {
          label: "Tin dịch vụ",
          link: `https://medpro.vn/tin-tuc/${NewsCategories.TIN_DICH_VU}`
        },
        {
          label: "Tin Y Tế",
          link: `https://medpro.vn/tin-tuc/${NewsCategories.TIN_Y_TE}`
        },
        {
          label: "Y Học thường thức",
          link: `https://medpro.vn/tin-tuc/${NewsCategories.Y_HOC_THUONG_THUC}`
        }
      ]
    },
    {
      title: "Về Medpro",
      link: "",
      children: [
        {
          label: "Giới thiệu",
          link: "https://medpro.vn/gioi-thieu"
        },
        {
          label: "Điều khoản dịch vụ",
          link: "https://medpro.vn/dieu-khoan-dich-vu"
        },
        {
          label: "Chính sách bảo mật",
          link: "https://medpro.vn/chinh-sach-bao-mat"
        },
        {
          label: "Quy định sử dụng",
          link: "https://medpro.vn/quy-dinh-su-dung"
        }
      ]
    }
  ],
  downloads: {
    dkbct: LINK_DANG_KY_BO_CO_THUONG,
    tbbct: LINK_THONG_BAO_BO_CO_THUONG,
    android: LINK_ANDROID_APP,
    ios: LINK_IOS_APP
  }
};
